// @flow
import experimentalGridHandler from 'app/common/lib/TraceLogger/gridHandler/experimentalGridHandler';
import experiments from 'app/common/lib/experiments';
import legacyGridHandler from 'app/common/lib/TraceLogger/gridHandler/legacyGridHandler';
import type { GridHandlerOptions, GridHandler } from 'app/common/lib/TraceLogger/gridHandler/types';

export const inNewTraceLoggerExperiment = () =>
  /^(enabled|employees)/.test(
    experiments.getInstance().v2ActivateExperiment('web_tracelogger_v3') || '',
  );

export const getGridHandler = (options: GridHandlerOptions): GridHandler =>
  inNewTraceLoggerExperiment() ? experimentalGridHandler(options) : legacyGridHandler(options);
